<template>
  <div>

    <el-main>
      <!-- <el-row>
        <el-col :span="24">
          <div style="text-align:right">
            企业帐号有效期：{{new Date(power.START_TIME).getTime()|dateFilter}}-{{new Date(power.END_TIME).getTime()|dateFilter}}
          </div>
        </el-col>
      </el-row> -->
      <template>
        <el-tabs @tab-click="changeTab"
                 v-model="activeName"
                 type="card">
          <el-tab-pane label="用户"
                       name="user">
            <user @searchReport="searchReport" />
          </el-tab-pane>
          <el-tab-pane label="报告"
                       name="report">
            <report :username="username" />
          </el-tab-pane>
        </el-tabs>
      </template>
    </el-main>

  </div>
</template>

<script>
import user from '../components/biz/user.vue'
import report from '../components/biz/report.vue'

import moment from 'moment'
export default {
  name: 'biz',
  data: function () {
    return {
      activeName: 'user',
      power: {},
      username: ''

    }
  },
  filters: {
    dateFilter: function (v) {
      return moment(new Date(parseInt(v))).format('YYYY/MM/DD')
    }
  },
  methods: {
    changeTab () {
      this.username = ''
    },
    searchReport (username) {
      this.username = username
      this.activeName = 'report'
    }
  },
  components: {
    user, report
  },
  mounted () {
    let _this = this
    this.axios.get('/api/web/csmarUser/querybclientauthlist').then(resp => {
      _this.power = (resp.data && resp.data.Data && resp.data.Data[0]) || {}
    })
  },
  watch: {

  }
}
</script>
<style scope>
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/app/biz.vue